module.exports = __webpack_public_path__ + "img/電気回路_5_8_2.6055d9bb.png";